import {apiConstants, config, downloadBlob, mockResolveApiCall, requestOptions, requestTypes, sendRequest} from "../../Utilities/Api";

class ServerStudentCensusApi {

    static getCurrentCensusStatus() {
        return sendRequest(
            requestOptions(config.URL + `census`,
                requestTypes.GET,
            ),
        );
    }

    static prepareForOpenCensus() {
        return sendRequest(
            requestOptions(config.URL + `census/open-census`,
                requestTypes.POST,
            ),
        );
    }

    static setManualCensusFimcAdminReviewDate() {
        return sendRequest(
            requestOptions(config.URL + `census/admin-review-census`,
                requestTypes.POST,
            ),
        );
    }

    static setManualCensusEndDate() {
        return sendRequest(
            requestOptions(config.URL + `census/end-census`,
                requestTypes.POST,
            ),
        );
    }

    static exportStudentsReport(studentSearchCriteria: Record<string, unknown>) {
            const queryParameters = new URLSearchParams(studentSearchCriteria as Record<string, string>).toString();

            return downloadBlob(
                requestOptions(`${config.URL}reports/students_census/export?${queryParameters}`,
                    requestTypes.GET,
                    null,
                    apiConstants.successMessage.report.REPORT_DOWNLOADED));
        }
    }

    //************************************************** MOCK API SERVER CALLS ****************************************

    class MockStudentCensusApi {

        static getCurrentCensusStatus() {
            return mockResolveApiCall("0", "");
        }

        static prepareForOpenCensus() {
            return mockResolveApiCall({}, "");
        }

        static setManualCensusFimcAdminReviewDate() {
            return mockResolveApiCall({}, "");
        }

        static setManualCensusEndDate() {
            return mockResolveApiCall({}, "");
        }

        static exportStudentsReport() {
            return mockResolveApiCall({}, "");
        }
    }

    export const studentCensusApi = config.environment.MODE === config.modes.SERVER ? ServerStudentCensusApi : MockStudentCensusApi;
